import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\BatchOperation\RenumberBatchOperationController::__invoke
* @see app/Http/Controllers/BatchOperation/RenumberBatchOperationController.php
* @route '/api/batch-operations/renumber/proposal'
*/
const RenumberBatchOperationController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: RenumberBatchOperationController.url(options),
    method: 'post',
})

RenumberBatchOperationController.definition = {
    methods: ["post"],
    url: '/api/batch-operations/renumber/proposal',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BatchOperation\RenumberBatchOperationController::__invoke
* @see app/Http/Controllers/BatchOperation/RenumberBatchOperationController.php
* @route '/api/batch-operations/renumber/proposal'
*/
RenumberBatchOperationController.url = (options?: RouteQueryOptions) => {
    return RenumberBatchOperationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BatchOperation\RenumberBatchOperationController::__invoke
* @see app/Http/Controllers/BatchOperation/RenumberBatchOperationController.php
* @route '/api/batch-operations/renumber/proposal'
*/
RenumberBatchOperationController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: RenumberBatchOperationController.url(options),
    method: 'post',
})

export default RenumberBatchOperationController